import { gql } from '@apollo/client';

export const TRANSFER_COMPANIES = gql`
  query TransferCompanies($data: TransferCompanyParamsInput!) {
    transferCompanies(data: $data) {
      results {
        id
        invoiceAddress {
          countryCode
        }
        onboardingStatus
        organization {
          name
          id
        }
        user {
          name
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const TRANSFER_COMPANIES_NAMES = gql`
  query TransferCompanies($data: TransferCompanyParamsInput!, $skip: Boolean!) {
    transferCompanies(data: $data) @skip(if: $skip){
      results {
        id
        organization {
          name
          id
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const CREATE_TRANSFER_COMPANY = gql`
  mutation CreateTransferCompany($data: TransferCompanyInput!) {
    createTransferCompany(data: $data)
  }
`;

export const UPDATE_TRANSFER_COMPANY = gql`
  mutation CreateTransferCompany($data: TransferCompanyInput!) {
    createTransferCompany(data: $data)
  }
`;

export const REMOVE_TRANSFER_COMPANY = gql`
  mutation CreateTransferCompany($data: TransferCompanyInput!) {
    createTransferCompany(data: $data)
  }
`;

export const TRANSFER_COMPANY_DETAILS = gql`
  query transferCompanyDetails($id: Int!) {
    transferCompany(id: $id) {
      id
      organization {
        id
        name
      }
      onboardingStatus
      taxiLicenseFileId
      taxiLicenseFile {
        externalKey
        contentType
      }
      chamberOfCommerceLicenseFileId
      chamberOfCommerceLicenseFile {
        externalKey
        contentType
      }
      websiteUrl
      mainLanguage
      spokenLanguages
      vatNumber
      vatRegion
      cocNumber
      ibanCode
      ibanAccountHolder
      swiftCode
      payoneerId
      preferredPayoutMethod
      invoicingFrequency
      paymentTermsDays
      managedByUserId
      phone
      invoicingCurrencyCode
      licenseExpiry
      invoiceAddress {
        countryCode
      }
      payoneerId
    }
  }
`;

export const TRANSFER_COMPANY_NAME = gql`
  query transferCompanyDetails($id: Int!, $skip: Boolean!) {
    transferCompany(id: $id) @skip(if: $skip) {
      organization {
        name
        id
      }
    }
  }
`;

export const UPDATE_TRANSFER_COMPANY_DETAILS = gql`
  mutation UpdateTransferCompanyDetails($data: TransferCompanyUpdateInput!) {
    updateTransferCompany(data: $data)
  }
`;

export const TRANSFER_COMPANY_ADDRESSES = gql`
  query TransferCompanyPostalAddress($id: Int!) {
    transferCompanyPostalAddress(id: $id) {
      companyName
      toTheAttentionOf
      street
      streetNumber
      streetNumberExtension
      city
      postOfficeBox
      zipCode
      countryCode
      email
    }
    transferCompanyInvoiceAddress(id: $id) {
      companyName
      toTheAttentionOf
      street
      streetNumber
      streetNumberExtension
      city
      postOfficeBox
      zipCode
      countryCode
      email
    }
    countries {
      code
      displayName
    }
  }
`;

export const UPDATE_TRANSFER_COMPANY_POSTAL_ADDRESS = gql`
  mutation UpdateTransferCompanyPostalAddress($data: TransferCompanyAddressInput!, $id: Int!) {
    updateTransferCompanyPostalAddress(data: $data, id: $id)
  }
`;

export const UPDATE_TRANSFER_COMPANY_INVOICE_ADDRESS = gql`
  mutation UpdateTransferCompanyInvoiceAddress($data: TransferCompanyAddressInput!, $id: Int!) {
    updateTransferCompanyInvoiceAddress(data: $data, id: $id)
  }
`;

export const TAXI_LICENSE_UPLOAD = gql`
  mutation($id: Int!, $file: Upload!) {
    uploadTaxiLicenseFile(id: $id, file: $file)
  }
`;

export const COC_LICENSE_UPLOAD = gql`
  mutation($id: Int!, $file: Upload!) {
    uploadChamberOfCommerceLicenseFile(id: $id, file: $file)
  }
`;

export const TRANSFER_COMPANY_MEETING_POINTS = gql`
  query transferCompanyMeetingPoints($hubTenderId: Int!) {
    transferCompanyMeetingPoints(hubTenderId: $hubTenderId) {
      results {
        id
        hubTenderId
        title
        description
        mapFileId
        mapFile {
          contentType
          externalKey
        }
        geographicLocation {
          lat
          lng
        }
        meetingPointFiles {
         file {
          externalKey
          contentType
          displayName
         }
         fileType
         fileId
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const CREATE_TRANSFER_COMPANY_MEETING_POINT = gql`
  mutation CreateTransferCompanyMeetingPoint($data: MeetingPointInput!) {
    createTransferCompanyMeetingPoint(data: $data) {
      id
    }
  }
`;

export const UPDATE_TRANSFER_COMPANY_MEETING_POINT = gql`
  mutation UpdateTransferCompanyMeetingPoint($data: MeetingPointInput!) {
    updateTransferCompanyMeetingPoint(data: $data) {
      id
    }
  }
`;

export const REMOVE_TRANSFER_COMPANY_MEETING_POINT = gql`
  mutation RemoveTransferCompanyMeetingPoint($meetingPointId: Int!) {
    removeTransferCompanyMeetingPoint(meetingPointId: $meetingPointId)
  }
`;

export const UPLOAD_TRANSFER_COMPANY_MEETING_POINT_MAP_IMAGE = gql`
  mutation($id: Int!, $file: Upload!) {
    uploadTransferCompanyMeetingPointMapImage(id: $id, file: $file)
  }
`;

export const REMOVE_TRANSFER_COMPANY_MEETING_POINT_IMAGE = gql`
  mutation RemoveTransferCompanyMeetingPointImage($meetingPointId: Int!, $fileId: Int!) {
    removeTransferCompanyMeetingPointImage(meetingPointId: $meetingPointId, fileId: $fileId)
  }
`;

export const UPLOAD_TRANSFER_COMPANY_MEETING_POINT_IMAGE = gql`
  mutation($meetingPointId: Int!, $file: Upload!, $fileType: String!) {
    uploadTransferCompanyMeetingPointImage(meetingPointId: $meetingPointId, file: $file, fileType: $fileType)
  }
`;

export const DESTINATION_MANAGERS = gql`
  query DestinationManagers {
    destinationManagers {
      id
      name
      email
    }
  }
`;

export const HUB_TENDER_EXPIRATION_SETTINGS = gql`
  query HubTenderExpirationSettings($params: HubTenderExpirationSettingsRequestParams!)  {
    hubTenderExpirationSettings(params: $params) {
      results {
        id
        hubTenderId
        days
        startTime
        endTime
        expirationMinutes
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const CREATE_HUB_TENDER_EXPIRATION_SETTING = gql`
  mutation CreateHubTenderExpirationSetting($params: HubTenderExpirationSettingParams!) {
    createHubTenderExpirationSetting(params: $params) {
      id
    }
  }
`;

export const UPDATE_HUB_TENDER_EXPIRATION_SETTING = gql`
  mutation UpdateHubTenderExpirationSetting($params: HubTenderExpirationSettingParams!) {
    updateHubTenderExpirationSetting(params: $params) {
      id
    }
  }
`;

export const REMOVE_HUB_TENDER_EXPIRATION_SETTING = gql`
  mutation RemoveHubTenderExpirationSetting($id: Int!) {
    removeHubTenderExpirationSetting(id: $id)
  }
`;

export const CREATE_TRANSFER_COMPANY_SERVICE_ACCOUNT = gql`
  mutation CreateTransferCompanyServiceAccount($params: TransferCompanyServiceAccountParams!, $id: Int!) {
    createTransferCompanyServiceAccount(params: $params, id: $id){
      userId
      password
      existingUser
    }
  }
`;

export const TRANSCO_COMMUNICATION_PREFERENCES = gql`
  query TranscoCommunicationPreferences($id: Int!) {
    transcoCommunicationPreferences(id: $id) {
       storeOfferEvents
       storeJourneyEvents
       storeInvoiceEvents
       sendOfferEmails
       sendJourneyEmails
       receiveWebhookEvents
       webhookUrl
       webhookDeliveryAttemptsCount
       alwaysCreateNewOffer
       webhookHmac
    }
  }
`;

export const UPDATE_TRANSCO_COMMUNICATION_PREFERENCES = gql`
  mutation UpdateTranscoCommunicationPreferences($data: TranscoCommunicationPreferencesInput!, $id: Int!) {
    updateTranscoCommunicationPreferences(data: $data, id: $id)
  }
`;

export const BOOKING_WINDOWS = gql`
  query BookingWindows($params: BookingWindowsParams!) {
    bookingWindows(params: $params) {
      results {
        id
        hubTenderId
        fromTime
        toTime
        weekDays
        vehicleCategory
        numberOfHoursInbound
        numberOfHoursOutbound
        type
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const CREATE_BOOKING_WINDOW = gql`
  mutation CreateBookingWindow($data: BookingWindowInput!) {
    createBookingWindow(data: $data)
  }
`;

export const UPDATE_BOOKING_WINDOW = gql`
  mutation UpdateBookingWindow($data: BookingWindowInput!, $id: Int!) {
    updateBookingWindow(data: $data, id: $id)
  }
`;

export const DELETE_BOOKING_WINDOW = gql`
  mutation DeleteBookingWindow($id: Int!) {
    deleteBookingWindow(id: $id)
  }
`;
